import StatCard, { type StatCardProps } from "../molecules/StatCard";

interface StatsGridProps {
  stats: StatCardProps[];
  columns?: 2 | 3 | 4;
}

export const StatsGrid = ({ stats, columns = 3 }: StatsGridProps) => {
  const gridColsClass = {
    2: "lg:grid-cols-2",
    3: "lg:grid-cols-3",
    4: "lg:grid-cols-4",
  }[columns];

  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-2 ${gridColsClass} gap-x-[19px] gap-y-5`}
    >
      {stats.map((stat, i) => (
        <StatCard key={i} {...stat} />
      ))}
    </div>
  );
};
